// extracted by mini-css-extract-plugin
export default {"imageContent":"jo-z","modal":"ko-z"};